import { render, staticRenderFns } from "./DietConfigurator.vue?vue&type=template&id=35dbda90&"
import script from "./DietConfigurator.vue?vue&type=script&lang=js&"
export * from "./DietConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports